import React from 'react';
import { Divider as MUIDivider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

export interface DividerProps {
  marginTop: string;
  marginBottom: string;
  color?: string;
}

const Divider: React.FC<DividerProps> = ({
  marginTop,
  marginBottom,
  color,
}) => {
  const useStyles = makeStyles()({
    root: {
      marginTop: marginTop,
      marginBottom: marginBottom,
      backgroundColor: color ?? patientAccessTheme.palette.grey[300],
    },
  });

  const { classes } = useStyles();

  return <MUIDivider className={classes.root} />;
};

export default Divider;
